.field {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.label {
  display: block;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text);
  margin-bottom: var(--space-1);
}

.required {
  color: var(--color-error);
}

.error {
  font-size: var(--font-size-sm);
  color: var(--color-error);
  margin: var(--space-1) 0 0 0;
}
